import { VydejMenu } from '../../vydej/vydejmenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import { ChartDoc } from '../../charts/ChartDoc';

import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';

const VydejChartDocPage = () => {
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.vydej ? (
        <AppWrapper
          appType={APP_TYPE.VYDEJ}
          menu={<VydejMenu />}
          resource='RelatedApps'
          action='action.allow_charts'
        >
          <ChartDoc />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default VydejChartDocPage;
